import React from 'react';
import LegalPage from '../components/LegalPage';
import Seo from '../components/Seo';

export default function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy">
      <Seo
        path="/privacy"
        title="Privacy Policy — LottoPickle"
        description="How LottoPickle collects, uses, and protects your information. We require no login and do not sell personal data."
      />
      <h2>1. Overview</h2>
      <p>LottoPickle ("we", "our", "the Service") respects your privacy. This policy explains what information we collect, how we use it, and your rights regarding that information.</p>

      <h2>2. Information We Collect</h2>
      <p><strong>Information you provide:</strong></p>
      <ul>
        <li><strong>Email address</strong> — if you subscribe to our newsletter. Used solely for sending updates and can be removed at any time by unsubscribing.</li>
      </ul>
      <p><strong>Information collected automatically:</strong></p>
      <ul>
        <li><strong>Anonymous user identifier</strong> — a randomly generated ID stored in your browser's local storage, used to manage your subscription status through Stripe. This is not tied to your identity.</li>
        <li><strong>Basic analytics</strong> — we may collect anonymized usage data such as pages visited and features used to improve the Service. No personal information is included.</li>
      </ul>
      <p><strong>Information we do NOT collect:</strong></p>
      <ul>
        <li>We do not require account creation or login</li>
        <li>We do not collect names, phone numbers, or physical addresses</li>
        <li>We do not track your lottery purchases or gambling activity</li>
        <li>We do not sell or share personal data with advertisers</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To provide and maintain the Service</li>
        <li>To manage subscriptions through our payment processor (Stripe)</li>
        <li>To send newsletter emails if you have opted in</li>
        <li>To improve the Service based on anonymized usage patterns</li>
      </ul>

      <h2>4. Third-Party Services</h2>
      <p>We use the following third-party services:</p>
      <ul>
        <li><strong>Stripe</strong> — payment processing and subscription management. Their privacy policy is available at stripe.com/privacy.</li>
        <li><strong>Mailgun</strong> — email delivery for newsletters. Their privacy policy is available at mailgun.com/legal/privacy-policy.</li>
        <li><strong>New York State Open Data</strong> — source of lottery draw data. This is publicly available government data.</li>
      </ul>

      <h2>5. Data Storage and Security</h2>
      <p>Your anonymous user ID is stored locally in your browser. Newsletter email addresses are stored securely through our email service provider. We implement reasonable security measures to protect your information but cannot guarantee absolute security.</p>

      <h2>6. Cookies and Local Storage</h2>
      <p>We use browser local storage to:</p>
      <ul>
        <li>Store your anonymous user ID for subscription management</li>
        <li>Remember your preferences (selected game, view settings)</li>
      </ul>
      <p>We do not use tracking cookies or third-party advertising cookies.</p>

      <h2>7. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li><strong>Unsubscribe</strong> from newsletter emails at any time using the link in each email</li>
        <li><strong>Delete local data</strong> by clearing your browser's local storage</li>
        <li><strong>Request information</strong> about any data we hold related to your email address</li>
        <li><strong>Request deletion</strong> of your email from our mailing list by contacting us</li>
      </ul>

      <h2>8. Children's Privacy</h2>
      <p>The Service is not directed at children under 18. We do not knowingly collect information from minors. If you believe a child has provided us with personal information, please contact us and we will delete it.</p>

      <h2>9. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Changes take effect upon posting to this page. We encourage you to review this page periodically.</p>

      <h2>10. Contact</h2>
      <p>For privacy-related questions or requests, contact us at <a href="mailto:info@lottopickle.com">info@lottopickle.com</a>.</p>
    </LegalPage>
  );
}
